import React, { useState, useEffect, useRef } from "react";
import ApplicationLayout from "../../../../layouts/ApplicationLayout";
import { Helmet } from "react-helmet";
import { DisplayListPagination, PeriodSelectionWithCustom } from "../../../../components/TapUi";
import TapSelect from "../../../../components/ui/TapSelect";
import TapIcon from "../../../../services/TapIcon";
import { useDispatch, useSelector } from "react-redux";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import TrackFuelValue from "./TrackFuelValue";
import { authLoginAndGetJWTToken } from "../../../../store/actions/OmniComm/OmniCommAuthAction";
import HttpAPICall from "../../../../services/HttpAPICall";
import { IAM_API_BASE_URL_3 } from "../../../../services/TapApiUrls";
import Loader from "../../../../components/ui/Loader/Loader";
import DateService from "../../../../services/DateService";
import FuelValueDataGraph from "./FuelValueDataGraph";
import StatisticReport from "./StatisticReport";
import EventsReport from "./EventsReport";
import FuelVolumeWithEventsChart from "./FuelVolumeWithEventsChart";
import RefuelingAndDrainingReport from "./RefuelingAndDrainingReport";
import TrackingMap from "./TrackingMap";
import DeviceHistory from "./DeviceHistory";
import { toast } from "react-toastify";
import VoltageGraph from "./VoltageGraph";
import TripSessionDetail from "./TripSessionDetailData";


const IotReports = (props) => {
    
    const all_periods               =   useSelector(state => {
        const periods       =   state.app?.all_periods || [];
        return [...periods, { key: 'custom', display: 'Custom Date Range' }];
    });

    const now               =   new Date();
    const currentDay        =   now.getDay(); 
    const startOfWeek       =   new Date(now);
    startOfWeek.setDate(now.getDate() - currentDay);
    startOfWeek.setHours(0, 0, 0, 0);
    
    const endOfWeek         =   new Date(now);
    endOfWeek.setDate(now.getDate() + (6 - currentDay));
    endOfWeek.setHours(23, 59, 59, 999);


    const dispatch                  =   useDispatch();
    const accessToken               =   useSelector(state => state.auth.access_token);
    const [assetData, setAssetData] =   useState({
        loading     :   false,
        list        :   [],
        meta        :   {}
    });
    const [reportOptions, setReportOptions] =   useState([
        { value: 1, label: "Fuel Volume" },
        { value: 2, label: "Statistic" },
        { value: 3, label: "Events" },
        { value: 4, label: "Fuel Volume + Events" },
        { value: 5, label: "Refueling and Draining Report" },
        { value: 6, label: "Asset Location Status"},
         { value: 7, label: "Asset History" },
         { value: 8, label: "Voltage Graph" },
         { value: 9, label: "Animated Map" }


    ]);
    const initialFormState = {
        asset_id            :   null,
        date_range          :   "current_week",
        date_range_start    :   DateService.dateFormat(startOfWeek, 'YYYY-MMM-DD'),
        date_range_end      :   DateService.dateFormat(endOfWeek, 'YYYY-MMM-DD'),
        uuid                :   '',
        report_type         :   '',
        asset               :   null,
        checkbox_ids        :   [],
        checkbox_id         :   null
    };
    const [formData, setFormData] = useState(initialFormState);
    const [submitFormData, setSubmitFormData] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false)
   const isMulti =
    formData.report_type === "Asset Location Status";

    useEffect(() => {
        getIoTAssets()
    }, []);

    // useEffect(() => {
    //     setFormData(prev => ({
    //         ...prev,
    //         asset_id: null,
    //         asset_ids: [],
    //         uuid: '',
    //         asset: null
    //     }));
    // }, [formData.report_type]);
    const getIoTAssets = (page = 1) => {
        setAssetData(pre => ({ ...pre, loading: true }));
        let params = {
            only_iot_asset: 'Y',
            page
        }
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_3 + '/assets', accessToken, params, {}, (response) => {
            const assets        =   response.data.data.filter(d => d.iot_device && d.iot_device.terminal_id)
            
            const asset_ids    =   assets.map(d => (d.iot_device.terminal_id));
            setSubmitFormData(pre => ({...pre, asset_ids}))
            setAssetData(pre => ({ ...pre, list: assets, meta: response.data.meta }))
        }).then(() => {
            dispatch(authLoginAndGetJWTToken());
            setAssetData(pre => ({...pre, loading: false}))
        });
    }


    const selectAsset = (asset) => {
        
      if (!asset.iot_device) return;

        const id = asset.iot_device?.terminal_id;
        const checkboxSelectId = asset.asset_id

        if (isMulti) {
            setFormData(prev => {
                const alreadySelected = prev.asset_ids?.includes(id);

                return {
                    ...prev,
                    
                    checkbox_ids: prev.checkbox_ids?.includes(checkboxSelectId)
                        ? prev.checkbox_ids.filter(a => a !== checkboxSelectId)
                        : [...(prev.checkbox_ids || []), checkboxSelectId],

                    // asset_ids: alreadySelected
                    //     ? prev.asset_ids.filter(a => a !== id)
                    //     : [...(prev.asset_ids || []), id]
                };
            });
        } else {
            setFormData(prev => ({
                ...prev,
                asset_id        :   id,
                asset_ids       :   [id],
                checkbox_ids    :   [checkboxSelectId],
                checkbox_id     :   checkboxSelectId,
                uuid            :   asset.iot_device.manufacturer_device_uuid,
                asset           :   asset,
            }));
        }
    };

    const getReportComponent    =   ()  => {
        switch (submitFormData?.report_type) {
            case 'Statistic' :
                return <StatisticReport formData={submitFormData}/>
            case 'Events' :
                return <EventsReport formData={submitFormData}/>
            case 'Fuel Volume' :
                return <FuelValueDataGraph formData={submitFormData}/>
            case 'Fuel Volume + Events' :
                return <FuelVolumeWithEventsChart formData={submitFormData}/>
            case 'Refueling and Draining Report' :
                return <RefuelingAndDrainingReport formData={submitFormData}/>
            case 'Asset Location Status' :
                return <TrackingMap formData={submitFormData}/>
                  case "Asset History":
            return <DeviceHistory formData={submitFormData} />;
                case "Voltage Graph":
            return <VoltageGraph formData={submitFormData} />;
                  case "Animated Map":
            return <TripSessionDetail formData={submitFormData} />;
            
            default:
                return null
        }
    }

    const handleSubmitFormData    =   ()  => {
        if (!formData.checkbox_ids.length) {
            toast.error("Please select asset", {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }
         setIsSubmitting(true);

        const selectedAssets = assetData.list.filter(asset =>
            formData.checkbox_ids.includes(asset.asset_id)
        );

        const asset_ids = [
            ...new Set(
                selectedAssets.map(
                    asset => asset.iot_device?.terminal_id
                )
            )
        ];
        const imeis = [
            ...new Set(
                selectedAssets.map(asset => asset.iot_device?.imei_no)
            )
        ];

        setSubmitFormData(pre => ({
            ...pre,
            asset_id            :   formData.asset_id,
            asset_ids           ,
            imeis,
            date_range_start    :   formData.date_range_start,
            date_range_end      :   formData.date_range_end,
            uuid                :   formData.uuid,
            report_type         :   formData.report_type,
            asset               :   formData.asset
        }))
        setIsSubmitting(false);
    }

    const closeReport = () => {
        setFormData(initialFormState);
        setSubmitFormData({});
        props.history.push({ pathname: `/iot_reports` });
    }
    return (
        <ApplicationLayout>
            <Helmet>
                <title>IOT/GPS - Reports</title>
            </Helmet>
            <div className="page_title row m0">
                <div className="col-sm-12">
                    <h3>IOT/GPS Reports</h3>
                    {/* <div className="text-end pt-2">
                        <button type="button" className="btn btn-secondary" onClick={closeReport}>
                            <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                        </button>
                    </div> */}
                </div>
            </div>
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div className="col-sm-3 pr0 bg-white">
                        {assetData.loading 
                        ? <Loader/>
                            :
                            <div className="bg-white p-2" >
                                <label className="mb-1">Reports</label>
                                <div style={{ position: "relative", zIndex: 5 }}>
                                    <TapSelect
                                        options={reportOptions}
                                        value={reportOptions.filter(s => s.label == formData.report_type)}
                                        changeEvent={(opt) => {
                                            setFormData(pre => ({ ...pre, report_type: opt ? opt.label : '' }))
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder="Select Report"
                                    />
                                </div>
                                <div className="mt-2">
                                    <label className="mb-1">Period</label>
                                    <PeriodSelectionWithCustom
                                        zIndex={2}
                                        cols='col-sm-12'
                                        menuPlacement={"bottom"}
                                        periods={all_periods}
                                        value={formData.date_range}
                                        startDate={formData.date_range_start}
                                        endDate={formData.date_range_end}
                                        onSelectPeriod={(period, startDate, endDate) => {
                                            setFormData(prev => ({
                                                ...prev,
                                                date_range: period,
                                                date_range_start: startDate || '',
                                                date_range_end: endDate || ''
                                            }));
                                        }}
                                    />
                                </div>

                                <div className="mt-2 flex-grow-1 d-flex flex-column mb-5 pb-5">
                                    <label className="mb-2">Assets</label>
                                    <div className="mb-2" style={{ maxHeight: "150px", overflowY: "scroll", height: "100%" }}>
                                        {assetData.list.map((asset) => (
                                            <label
                                                key={asset.id}
                                                className="d-flex align-items-center mb-2"
                                                style={{ cursor: "pointer" }}
                                            >
                                                <input
                                                    id={asset.name}
                                                    type="checkbox"
                                                    name="asset_checkbox"
                                                    onChange={() => selectAsset(asset)}
                                                    checked={
                                                        isMulti
                                                            ? formData.checkbox_ids?.includes(asset.asset_id)
                                                            : formData.checkbox_id === asset.asset_id
                                                    }
                                                />
                                                <span htmlFor={asset.name} className="pl10">{asset.name}</span>
                                            </label>
                                        ))}
                                    </div>
                                    <DisplayListPagination meta={assetData.meta} onPageChange={(e) => getIoTAssets(e.selected + 1)} zIndex={2} />
                                    <div className="text-end">
                                        <button className="btn btn-primary my-2" disabled={isSubmitting} onClick={() => handleSubmitFormData()}>Submit</button>
                                    </div>
                                </div>
                            </div>
                        }                   
                    </div>

                    <div style={{ maxHeight: "95vh", overflowY: "scroll" }} className="col-sm-9 tap_border_left p-2 pageTbl bg-white">
                        {
                            assetData.loading 
                            ?
                            <Loader/>
                            :
                            getReportComponent()
                        }
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
};

export default IotReports;